import { Card, Flex, Tooltip } from 'antd'
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons'

import {
  openModalAddUser,
  openModalDeleteUser,
} from 'src/pages/budget/budgetTeams/model'
import { PermissionType } from 'src/pages/budget/budgetTeams/types'
import {
  BUDGET_STEPS,
  cardStyles,
  CEO_NAME_TEAM,
  iconButtonStyle,
} from 'src/pages/budget/const'
import { useCeoTeam, useUsers } from 'src/pages/budget/hook'
import { UiText } from 'src/pages/budget/components'
import { useMap } from 'src/pages/budget/budgetTeams/hooks'
import { useUserProfile } from 'src/features/user'

type PropsType = {
  type: PermissionType
  userIds: string[]
  teamId: number
  level: number
}

const FONT_SIZES_MAP: Record<number, number> = {
  0: 22,
  1: 20,
  2: 18,
}

export const StageCard = ({ type, userIds, teamId, level }: PropsType) => {
  const { allUsersMap, adminsMap } = useUsers()
  const { ceoTeam } = useCeoTeam()
  const userProfile = useUserProfile()
  const { forbiddenDeleteUsersId, teamMap } = useMap()
  const teamName = teamMap.get(teamId)?.name
  const isOneCeo = teamName === CEO_NAME_TEAM && ceoTeam.length === 1

  const handleClickAdd = () => {
    openModalAddUser({ userIds, teamId, type })
  }
  const canDelete =
    !isOneCeo &&
    (adminsMap.has(userProfile.id) || ceoTeam.includes(userProfile.id))

  const canAdd =
    adminsMap.has(userProfile.id) ||
    ceoTeam.includes(userProfile.id) ||
    teamMap.get(teamId)?.permissions[type].includes(userProfile.id)

  return (
    <Card
      title={
        <UiText size={FONT_SIZES_MAP[level] ?? 16}>{BUDGET_STEPS[type]}</UiText>
      }
      type="inner"
      extra={
        canAdd && (
          <Tooltip title="Добавить сотрудника">
            <PlusOutlined
              onClick={handleClickAdd}
              style={{
                ...iconButtonStyle,
                color: 'var(--color-primary)',
                fontSize: 18,
              }}
            />
          </Tooltip>
        )
      }
      styles={cardStyles}
    >
      {userIds.map((id) => {
        const userName = allUsersMap.get(id)
        return (
          <Flex
            key={id}
            justify="space-between"
            align="center"
            style={{ height: 40 }}
          >
            <UiText ellipsis size={18}>
              {userName}
            </UiText>
            {!forbiddenDeleteUsersId.has(id) && canDelete && (
              <DeleteOutlined
                onClick={() =>
                  openModalDeleteUser({
                    userId: id,
                    teamId,
                    type,
                  })
                }
                style={{
                  ...iconButtonStyle,
                  color: 'var(--color-red-60)',
                  fontSize: 18,
                }}
              />
            )}
          </Flex>
        )
      })}
    </Card>
  )
}
